// extracted by mini-css-extract-plugin
export default {"root":"ContributionSuccess_root__3KbuN","icon":"ContributionSuccess_icon__3Di8A","content":"ContributionSuccess_content__2Nj5o"};